'use strict';

const mobileCheck = require('bunsen/helpers/mobileCheck');
const SV = require('server-vars');
const get = require('lodash.get');
const User = require('../../models/User');
const pageTypeHelper = require('../pageTypeHelper');
const {PAGE_TYPE} = require('../../constants/pageTypes');
const calloutHelper = require('../../../components/Callout/calloutHelper');
const calloutActions = require('../../../components/Callout/calloutActions');

function hasUserPermission() {
    return Promise.resolve(User.load())
        .then(() => {
            return User.getCurrentUser().hasPermission('B_INVOICE');
        });
};

function makeGraphQLRequest({userToken, userId, itemId}) {
    return fetch(`/soa/graphql/?userToken=${userToken}`, {
        json: true,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: `
                {
                    viewer {
                        transactions(viewName: "buyer.buyerPreInvoiceFilter", buyerId: "${userId}", itemId: "${itemId}") {
                            totalResults
                        }
                    }
                }
        `})
    }).then(response => {
        if (response.ok) {
            return response.json();
        }

        console.warn(`Can't get graphql data for view invoice callout rule!`);
        return {error: true};
    });
}

/**
 * Checks condition for view invoice callout.
 * Opens callout if condition is satisfied.
 * Condition:
 * is PDP page
 * is trade user
 * not mobile
 *
 * @return {Promise}
 */
const viewInvoiceCalloutRule = function viewInvoiceCalloutRule({context}) {
    const type = calloutHelper.CALLOUT_TYPE_VIEW_INVOICE;
    const canShowCallout = calloutHelper.canShowCallout({type});
    const isPDP = pageTypeHelper.isPageType(PAGE_TYPE.PDP);
    const isMobile = mobileCheck.any();

    if (!canShowCallout || !isPDP || isMobile || !User.loggedIn()) {
        return Promise.resolve({success: false});
    }

    return hasUserPermission()
        .then(userCanSeeInvoice => {
            if (userCanSeeInvoice) {
                return makeGraphQLRequest({
                    userToken: User.getUserToken(),
                    userId: User.getUserId(),
                    itemId: SV.get('data.pk')
                })
                .then(response => {
                    if (get(response, 'data.viewer.transactions.totalResults') || response.error) {
                        return {success: false};
                    }

                    context.executeAction(calloutActions.openCallout, {type});
                    return {success: true, type};
                });
            }

            return {success: false};
        });

};

module.exports = viewInvoiceCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/viewInvoiceCalloutRule.es.js